/**
 * WebMCP 资源入口
 * 注册所有游戏资源
 */
/* eslint-disable */
var gameState = require('./gameState');

// 导出所有资源
var resources = [
  gameState.gameStateResource,
];

// 资源映射表
var resourceMap = {};
for (var i = 0; i < resources.length; i++) {
  resourceMap[resources[i].uri] = resources[i];
}

module.exports = {
  resources: resources,
  resourceMap: resourceMap,
};



// WEBPACK FOOTER //
// ./src/webmcp/resources/index.js